// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"953e9d4d","453":"e30dcf31","732":"415406d8"}[chunkId] + ".chunk.js";
};